import { Button } from 'antd'
import { PrinterOutlined } from '@ant-design/icons'
import { datetimeToAusFormat, dateToAusFormat } from './util'
import { PatientDetailsType } from './AddsChart'
import { useState } from 'react'

type PrintButtonPropsType = {
  patientDetails: PatientDetailsType
  startTime: number
  endTime: number
  printToggle: () => void
}

const PrintButton = ({
  patientDetails,
  startTime,
  endTime,
  printToggle,
}: PrintButtonPropsType) => {
  const [isPrinting, setIsPrinting] = useState(false)
  const fileName = `${patientDetails.patientName}_ADDS_CHART_${datetimeToAusFormat(new Date(startTime))}_${datetimeToAusFormat(new Date(endTime))}`

  const printChart = async () => {
    printToggle()
    setIsPrinting(true)

    await new Promise((resolve) => setTimeout(resolve, 100))

    const printWindow = window.open('', fileName)
    if (!printWindow) {
      alert('Please allow pop-ups to print the chart')
      printToggle()
      setIsPrinting(false)
      return
    }

    const content = document.querySelector('.chart-body')?.outerHTML
    if (!content) {
      alert('Chart not found')
      printToggle()
      setIsPrinting(false)
      return
    }

    printWindow.document.write(`
        <html>
            <script>
              window.onload = function() {
                window.print();
                window.close();
              }
            </script>
            <head>
              <title>${fileName}</title>
              <style>
                @media print {
                  @page {
                    size: A4 portrait;
                    margin: 5mm;
                  }

                  .chart-row{
                    display: flex;
                    border: 0.5px solid #323232;
                  }

                  .chart-row:nth-child(1) {
                    display: flex;
                    flex: 2.5;
                  }

                  .chart-row:nth-child(2) {
                    display: flex;
                    flex: 21.5;
                    padding: 0 0;
                    border-left: 0.5px solid #323232;
                  }

                  .chart-title {
                    display: flex;
                    justify-content: center;
                  }

                  h1 {
                    font-size: 16px;
                  }

                  .patient-details {
                    width: 100%;
                    font-size: 12px;
                    line-height: 16px;
                    display: flex;
                    flex-direction: column;
                    margin-bottom: 2mm;
                  }

                  .patient-details--top {
                    display: flex;
                    width: 80%;
                    flex-direction: row;
                    justify-content: space-between;
                    height: 7mm;
                  }
                  .patient-details--bottom {
                    display: flex;
                    height: 7mm;
                  }

                  .chart-details {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    margin-top: 3mm;
                    font-size: 12px;
                  }
                }
              </style>
            
              </head>
            <body>
              <div class="chart-title">
                <h1>ADDS Chart</h1>
              </div>
              <div class="patient-details">
                <div class="patient-details--top">
                  <p>Patient Name: <strong>${patientDetails.patientName}</strong></p>
                  <p>DOB: <strong>${patientDetails.patientDOB ? dateToAusFormat(patientDetails.patientDOB) : ''}</strong></p>
                  <p>Age: <strong>${patientDetails.patientAge}</strong></p>
                </div>
                <div class="patient-details--bottom">
                  <p>Doctor: <strong>${patientDetails.doctorName}</strong></p>
                </div>
              </div>
              ${content}
              <div class="chart-details">
                <p>Printed on ${datetimeToAusFormat(new Date())}</p>
                <p><strong>${patientDetails.hospitalName}</strong></p>
              </div>
            </body>
        </html>
    `)
    printWindow.document.close()
    const checkWindowClosed = setInterval(() => {
      if (printWindow.closed) {
        clearInterval(checkWindowClosed)
        printToggle()
        setIsPrinting(false)
      }
    }, 100)
  }

  return (
    <Button
      onClick={printChart}
      type='primary'
      className='print-button'
      icon={<PrinterOutlined />}
      disabled={isPrinting}
    >
      {isPrinting ? 'Printing...' : 'Print Chart'}
    </Button>
  )
}

export default PrintButton
